import { useEffect } from 'react';
import { useLocation, navigate } from '@reach/router';
import queryString from 'query-string';
import { COACH_MARK_SUPPRESS_KEY } from '@smile-next/uikit';

const COACH_MARK_QUERY_PARAM = 'coachmark';

/**
 * URLクエリパラメータから coachmark=true を検出し、
 * localStorageに保存してからクエリパラメータを削除する
 */
export const useDemoModeStorage = () => {
    const location = useLocation();

    useEffect(() => {
        // クエリパラメータを解析
        const query = queryString.parse(location.search, { decode: true });

        // coachmark が含まれているかチェック
        if (query[COACH_MARK_QUERY_PARAM]) {
            // localStorageに保存
            localStorage.setItem(COACH_MARK_SUPPRESS_KEY, String(query[COACH_MARK_QUERY_PARAM] === 'true'));

            // クエリパラメータから coachmark を削除
            const newQuery = { ...query };
            delete newQuery[COACH_MARK_QUERY_PARAM];

            // 新しいクエリ文字列を生成
            const newSearch = queryString.stringify(newQuery);
            const newUrl = `${location.pathname}${newSearch ? `?${newSearch}` : ''}`;

            // URLを更新（履歴に残さずに置き換え）
            navigate(newUrl, { replace: true });
        }
    }, [location.search, location.pathname]);
};
